export { default } from './Lang';
